import remarkGfm from "remark-gfm";

/**
 * Plugin remark dùng chung cho MỌI chỗ render markdown do LLM sinh ra.
 *
 * react-markdown v10 chỉ hỗ trợ CommonMark, KHÔNG bật GFM sẵn. Thiếu plugin này
 * thì bảng ba cột mà backend sinh ra (vd mục "Đối chiếu hai tay" của bói chỉ tay)
 * không được nhận là bảng, và markdown gộp newline đơn thành dấu cách — người xem
 * thấy một đoạn văn dính đầy dấu | và :--- . Kèm theo GFM còn có strikethrough,
 * autolink và task list.
 *
 * Khai một mảng hằng ở module scope thay vì `[remarkGfm]` tại chỗ: mảng mới mỗi
 * lần render sẽ làm react-markdown dựng lại pipeline processor liên tục.
 */
export const MARKDOWN_REMARK_PLUGINS = [remarkGfm];
